import React, { useState, useEffect, useCallback, useRef } from "react";
import "../sass/CreativeStation.scss";
import { useDispatch, useSelector } from "react-redux";
import { MasonryBlock } from "../components/MasonryBlock/MasonryBlock";
import { getAllCreativeStationPosts } from "../actions/creative-station-actions/actions";
import { useHistory } from "react-router-dom";
import { SnippetsOutlined } from "@ant-design/icons";
import Head from "../components/Head";
import axiosInstance from "../config/axios-instance";
import { useQuery } from "react-query";
import ExampleProductCard from "../components/ProductCard/ExampleProductCard";
import { Spinner } from "../components/Spinner";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import { Drawer, message, Tooltip, Tabs, Image } from "antd";
import useWindowWidth from "../config/useWindowWidth";
import ProductServices from "../actions/products-actions/services";
import DenimProduct from "../components/ProductDetails/DenimProduct";
import KnitProduct from "../components/ProductDetails/KnitProduct";
import MixProduct from "../components/ProductDetails/MixProduct";
import BottomDrawer from "../components/BottomDrawer/BottomDrawer";
import ReactSelect from "react-select";
import { getCollaborators } from "../actions/order-actions/actions";
import { addProducttoFolder, createFolder, clearfolderToMoveTo } from "../actions/folders-actions/actions";
import Folder from "../components/Folder/Folder";
import PlusIcon from "../icons/PlusIcon";
import { Link } from "react-router-dom";
import "../components/AddToCollection/AddToCollection.scss";
import service3d from "../video/hero.webm";
import sv_1 from"../img/sv_1.webp"
import sv_2 from"../img/sv_2.webp"
import sv_3 from"../img/sv_3.webp"
import sv_4 from"../img/sv_4.webp"
import sv_5 from"../img/sv_5.webp"
import sv_6 from"../img/sv_6.webp"
import sv_7 from"../img/sv_7.webp"
import sv_8 from"../img/sv_8.webp"
import sv_9 from"../img/sv_9.webp"
import sv_10 from"../img/sv_10.webp"
import sv_11 from"../img/sv_11.webp"
import sv_12 from"../img/sv_12.webp"
import sv_13 from"../img/sv_13.webp"
import sv_14 from"../img/sv_14.webp"
import sv_15 from"../img/sv_15.webp"
import sv_16 from"../img/sv_16.webp"
import gif from "../video/gif_.webm";
import animation from "../video/annimation.webm"
import mouvment from "../video/mouvment.webm"
import LazyImg from "../components/Library/LazyImage";

interface Props {}

const ProcessMedia = ({ src, isMobile }: { src: any, isMobile: boolean }) => {
  const isVideo = src?.toString().toLowerCase().match(/\.(mp4|webm)$/);

  if (isVideo) {
    return (
      <video 
        src={src} 
        autoPlay 
        loop 
        muted 
        playsInline 
        className="process-video"
      />
    );
  }

  if (isMobile) {
    return (
      <LazyImg 
        src={src} 
        alt="Process step" 
        className="process-image-bg" 
      />
    );
  }

  return (
    <div 
      className="process-image-bg" 
      style={{ backgroundImage: `url(${src})` }}
    />
  );
};

export const Service3d = (props: Props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { moodboars, trending, threeDVideos, isLoading } = useSelector(
    (state: any) => state.posts
  );
  const { user, isAdmin } = useSelector((state: any) => state.auth);
  const folders = useSelector((state: any) => state.folders);
  const { collaborators } = useSelector((state: any) => state.orders);
  const width = useWindowWidth();

  const [quickViewProduct, setQuickViewProduct] = useState<any>(null);
  const [quickViewVisible, setQuickViewVisible] = useState(false);
  const [activeProcessTab, setActiveProcessTab] = useState('3D PROCESS');
  const [showCollectionForm, setShowCollectionForm] = useState(false);
  const [folderData, setFolderData] = useState({
    name: "",
    description: "",
    collaborator: [],
    season: '',
    year: ""
  });

  const customStylesCreateModern = {
    control: (base: any, state: any) => ({
      ...base,
      background: "white",
      borderColor: state.isFocused ? "#00468c" : "#e2e8f0",
      borderRadius: "8px",
      padding: "2px",
      fontSize: "14px",
      boxShadow: "none",
      "&:hover": {
        borderColor: "#00468c",
      },
    }),
    placeholder: (base: any) => ({
      ...base,
      color: "#94a3b8",
    }),
    menu: (base: any) => ({
      ...base,
      borderRadius: "12px",
      overflow: "hidden",
      boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
      border: "1px solid #e2e8f0",
    }),
    option: (base: any, state: any) => ({
      ...base,
      backgroundColor: state.isSelected ? "#00468c" : state.isFocused ? "#f1f5f9" : "white",
      color: state.isSelected ? "white" : "#1e293b",
      padding: "10px 12px",
      fontSize: "14px",
      cursor: "pointer",
      "&:active": {
        backgroundColor: "#00468c",
      },
    }),
  };

  const currentYear = new Date().getFullYear();
  const options_year = [
    { value: String(currentYear).slice(2), label: String(currentYear) },
    { value: String(currentYear + 1).slice(2), label: String(currentYear + 1) },
    { value: String(currentYear + 2).slice(2), label: String(currentYear + 2) },
    { value: String(currentYear + 3).slice(2), label: String(currentYear + 3) },
    { value: String(currentYear + 4).slice(2), label: String(currentYear + 4) },
  ];

  const options_season = [
    { value: 'ps', label: 'PS' },
    { value: 'ss', label: 'SS' },
    { value: 'pf', label: 'PF' },
    { value: 'fw', label: 'FW' }
  ];

  const handleCreateNewFolder = () => {
    if (!folderData.name) {
      message.error("Please specify the collection name!");
      return;
    }
    dispatch(createFolder({ ...folderData, product_id: quickViewProduct?.id }));
    setShowCollectionForm(false);
    setFolderData({ name: "", description: "", collaborator: [], season: '', year: "" });
    message.success("Collection created successfully");
  };

  useEffect(() => {
    dispatch(getCollaborators(""));
  }, [dispatch]);

  const openQuickView = async (product: any) => {
    setQuickViewProduct(product);
    setQuickViewVisible(true);
    try {
      const res = await ProductServices.getOneProduct(product.id);
      if (res.data) {
        setQuickViewProduct(res.data);
      }
    } catch (e) {
      console.log(e);
    }
  };

  React.useEffect(() => {
    dispatch(getAllCreativeStationPosts());
  }, []);



  const [products3d, setProducts3d] = useState<any[]>([]);
  const [productsLoading, setProductsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  const fetch3DProducts = async (page: number) => {
    setProductsLoading(true);
    let token = localStorage.getItem("token");
    try {
      const response = await axiosInstance.get(
        `/products?page=${page}&limit=30&collections=33&fabric_types=denim,knit`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      const { data, current_page, last_page } = response.data;
      if (data && data.length > 0) {
        setProducts3d((prev) => {
          const existingIds = new Set(prev.map((p) => p.id));
          const newProducts = data.filter((p: any) => !existingIds.has(p.id));
          return [...prev, ...newProducts];
        });
        setHasMore(current_page < last_page);
      } else {
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error fetching 3D products", error);
    } finally {
      setProductsLoading(false);
    }
  };

  useEffect(() => {
    fetch3DProducts(1);
  }, []);

  useEffect(() => {
    if (currentPage > 1) {
      fetch3DProducts(currentPage);
    }
  }, [currentPage]);

  const observer = useRef<IntersectionObserver | null>(null);
  const lastProductElementRef = useCallback(
    (node) => {
      if (productsLoading) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setCurrentPage((prevPage) => prevPage + 1);
        }
      });

      if (node) observer.current.observe(node);
    },
    [productsLoading, hasMore]
  );

  const { data: companies } = useQuery("companies", async () => {
    let token = localStorage.getItem("token");
    const res = await axiosInstance.get(`/admin/companies`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  });

  const { data: clients } = useQuery("clients", async () => {
    let token = localStorage.getItem("token");
    const res = await axiosInstance.get(`/clients/for_you`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  });

  console.log(moodboars);

  const processTabs = [
    {
      title: '3D PROCESS',
      blocks: [
        {
          heading: 'PATTERN',
          text: [
            'Import DXF files to validate production-ready styles and confirm garment shapes.',
            'Provide draped and blocked versions for styling and visual development.',
            'Use 3D pattern tools to create and refine patterns for export.'
          ],
          image: sv_11
        },
        {
          heading: 'DIGITAL ASSEMBLING',
          text: [
            'Block fitting once the garment is assembled.',
            'Use pressure and tension maps to support 3D fit validation.',
            'Fit garments on imported avatars, Alvanon avatars (if provided), or custom-fit avatars.'
          ],
          image: sv_12
        },
        {
          heading: 'TEXTURING & DETAILING',
          text: [
            'Digitalizing fabrics & refining denim textures.',
            'Develop realistic washes, fades, whiskers, and abrasion effects.',
            'Apply highly detailed custom maps for fabrics and seams to achieve enhanced realism.'
          ],
          image: gif
        }

        ,    {
          heading: 'FABRIC BEHAVIOR',
          text: [
            'Recreate fabric physics using the library or customize them per project.',
            'Pressure maps & tension maps help 3d fitting for fit confirmation.',
            'Scan or create custom fabrics tailored to specific developments.'
          ],
          image: mouvment
        }
          ,    {
          heading: 'RENDER & LIGHTS',
          text: [
            'Design cinematic lighting setups to highlight garment details and fabric behavior.',
            'Deliver high-resolution renders with realistic light, shadows, and depth.',
          ],
          image: sv_13
        }
          ,    {
          heading: 'ANIMATION',
          text: [
            'Garment-to-Full Outfit Avatar Animation',
            'In custom studios or immersive landscapes',
          ],
          image: animation
        }
      
      ]
    },
    {
      title: '3D VISUALS',
      galleryTop: [
        sv_4, sv_9, sv_5,
        sv_2, sv_1, sv_3,
        sv_7, sv_6, sv_10,
        sv_15, sv_14, sv_16
      ]
    },
    {
      title: '3D VIDEOS',
      blocks: [
        /* {
          heading: 'VIRTUAL RUNWAY',
          text: [
            'Dynamic 360-degree garment animations.',
            'Virtual runway shows and digital motion assets.',
            'Interactive video content for marketing and e-commerce.'
          ],
          image: 'https://images.unsplash.com/photo-1529139574466-a302d27f6054?auto=format&fit=crop&w=800&q=80'
        } */
      ]
    }
  ];

  return (
    <main className="creative_station">
      <Head title="Service 3D" />
      <div className="service-3d-hero">
        <div className="hero-banner">
          <video 
            autoPlay 
            loop 
            muted 
            playsInline 
            className="hero-bg"
          >
            <source src={service3d} type="video/mp4" />
          </video>
        </div>

        <div className="hero-content">
          <p className="description">
            At Demco, our 3D fashion design service powered by CLO VIRTUAL FASHION brings your denim visions to life digitally with realistic fabric drape, fit, and texture before a single physical sample is made. This smart, sustainable workflow speeds up decisions, cuts waste, and elevates your design process from concept to virtual reality.
          </p>
          
          <div className="hero-benefits">
            <div className="benefit-item">
              <div className="benefit-icon">
                <i className="fas fa-bolt"></i>
              </div>
              <h3>Speed & Efficiency</h3>
              <p>Up to 50–70% faster product development.</p>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon">
                <i className="fas fa-chart-line"></i>
              </div>
              <h3>Cost Reduction</h3>
              <p>30–50% reduction in physical sampling costs.</p>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon">
                <i className="fas fa-leaf"></i>
              </div>
              <h3>Sustainability Impact</h3>
              <p>Up to 80% fewer physical samples.</p>
            </div>
          </div>

          <div className="section-divider"></div>

          <Tabs defaultActiveKey="3D PROCESS" centered className="premium-tabs">
            {processTabs.map((tab) => (
              <Tabs.TabPane tab={tab.title} key={tab.title}>
                <div className="process-content-display">
                  <div className="w-100">
                    {/* Gallery Top */}
                    {tab.galleryTop && (
                      <div className="process-gallery-grid">
                        <Image.PreviewGroup>
                          {tab.galleryTop.map((img, i) => (
                            <div key={i} className="gallery-item">
                              <Image src={img} alt={`Gallery top ${i}`} loading="lazy" />
                            </div>
                          ))}
                        </Image.PreviewGroup>
                      </div>
                    )}

                    {/* Content Blocks */}
                    {tab.blocks?.map((block: any, index: number) => (
                       <div key={index} className="process-block">
                          <div className="process-text-content">
                            <h4>_{String(index + 1).padStart(2, '0')} {block.heading}</h4>
                            <div className="text-blocks">
                              {block.text.map((t: string, i: number) => (
                                <p key={i}>{t}</p>
                              ))}
                            </div>
                          </div>
                          <div className="process-image-container">
                            <ProcessMedia src={block.image} isMobile={width <= 992} />
                          </div>
                       </div>
                    ))}

                    {/* Masonry Block for 3D VIDEOS */}
                    {tab.title === '3D VIDEOS' && (
                       <div style={{ padding: "40px 0" }}>
                        <MasonryBlock
                          data={threeDVideos}
                          title=""
                          isLoading={isLoading}
                        />
                       </div>
                    )}

               
                  </div>
                </div>
              </Tabs.TabPane>
            ))}
               <Tabs.TabPane tab="3D PRODUCTS" key="2">
                 <div style={{ padding: "20px 0", marginBottom: "120px" }}>
                     {products3d.length === 0 && productsLoading ? (
                       <Spinner />
                     ) : (
                       <DragDropContext onDragEnd={() => {}}>
                         <Droppable droppableId="products-3d-droppable" direction="vertical">
                           {(provided) => (
                             <div 
                               className="row"
                               {...provided.droppableProps}
                               ref={provided.innerRef}
                             >
                                {products3d?.map((product: any, index: number) => {
                                 if (products3d.length === index + 1) {
                                   return (
                                     <div
                                       className="col-12 col-md-6 col-lg-3 mb-4"
                                       key={product.id}
                                       ref={lastProductElementRef}
                                     >
                                       <ExampleProductCard
                                         index={index}
                                         productPage={true}
                                         product={product}
                                         company={companies}
                                         clients={clients}
                                         onClick={openQuickView}
                                         item={{
                                           main: product.images[0] ? product.images[0].path : "",
                                           onHover: product.images[1] ? product.images[1].path : "",
                                         }}
                                       />
                                     </div>
                                   );
                                 } else {
                                   return (
                                     <div className="col-12 col-md-6 col-lg-3 mb-4" key={product.id}>
                                       <ExampleProductCard
                                         index={index}
                                         productPage={true}
                                         product={product}
                                         company={companies}
                                         clients={clients}
                                         onClick={openQuickView}
                                         item={{
                                           main: product.images[0] ? product.images[0].path : "",
                                           onHover: product.images[1] ? product.images[1].path : "",
                                         }}
                                       />
                                     </div>
                                   );
                                 }
                               })}
                               {productsLoading && <Spinner />}
                               {provided.placeholder}
                             </div>
                           )}
                         </Droppable>
                       </DragDropContext>
                     )}
                 </div>
              </Tabs.TabPane> 
          </Tabs>
        </div>
      </div>
      {user && isAdmin && user.permissions.includes("creative-station.update") && (
        <section className="d-flex justify-content-center">
          <button
            onClick={() => history.push("/add-creative-station")}
            className="add_post mr-1"
          >
            <i className="fas fa-pen-nib"></i> ADD NEW POST
          </button>
          <button
            onClick={() => history.push("/creative-station/draft")}
            className="add_post ml-1"
          >
            <SnippetsOutlined style={{ verticalAlign: 0 }} /> GO TO DRAFTS
          </button>
        </section>
      )}

      <Drawer
        title="Product Details"
        placement={width > 768 ? "right" : "bottom"}
        width={width > 768 ? 720 : "100%"}
        height={width > 768 ? "100%" : "85vh"}
        onClose={() => setQuickViewVisible(false)}
        visible={quickViewVisible}
        bodyStyle={{ padding: 0 }}
      >
        {quickViewProduct && (
          <div
            className="product_details_contanier"
            style={{ height: "100%", display: "flex", flexDirection: "column" }}
          >
            <div
              className="product_details_infos_scroll"
              style={{ border: "none", flex: 1, overflowY: "auto" }}
            >
              <div
                className="product_details_infos"
                style={{ height: "auto", overflow: "visible" }}
              >
                <div className="component_details">
                  {quickViewProduct.fabric_type === "denim" && (
                    <DenimProduct
                      key="denim_main"
                      oneProduct={quickViewProduct}
                      editMode={false}
                      setEditMode={() => {}}
                    />
                  )}
                  {(quickViewProduct.fabric_type === "knit" ||
                    quickViewProduct.fabric_type === "home_textile") && (
                    <KnitProduct
                      key="knit_main"
                      oneProduct={quickViewProduct}
                      editMode={false}
                      setEditMode={() => {}}
                    />
                  )}
                  {quickViewProduct.fabric_type === "mix" && (
                    <MixProduct
                      key="mix_main"
                      oneProduct={quickViewProduct}
                      editMode={false}
                      setEditMode={() => {}}
                    />
                  )}

                  {!["denim", "knit", "mix"].includes(
                    quickViewProduct.fabric_type
                  ) &&
                    quickViewProduct.fabric_types && (
                      <div key="alternate_view">
                        {quickViewProduct.fabric_types.name?.toLowerCase() ===
                          "denim" && (
                          <DenimProduct
                            key="denim_alt"
                            oneProduct={quickViewProduct}
                            editMode={false}
                            setEditMode={() => {}}
                          />
                        )}
                        {quickViewProduct.fabric_types.name?.toLowerCase() ===
                          "knit" && (
                          <KnitProduct
                            key="knit_alt"
                            oneProduct={quickViewProduct}
                            editMode={false}
                            setEditMode={() => {}}
                          />
                        )}
                        {quickViewProduct.fabric_types.name?.toLowerCase() ===
                          "mix" && (
                          <MixProduct
                            key="mix_alt"
                            oneProduct={quickViewProduct}
                            editMode={false}
                            setEditMode={() => {}}
                          />
                        )}
                      </div>
                    )}
                </div>

                {folders && folders.folders && folders.folders.length > 0 && (
                  <div style={{ position: "relative", padding: "20px", background: "#fff", height: "auto", minHeight: "400px" }}>
                    {showCollectionForm ? (
                      <div className="create_collection_form_modern" style={{
                        padding: "24px",
                        borderRadius: "16px",
                        display: "flex",
                        flexDirection: "column",
                        gap: "20px"
                      }}>
                        <h3 style={{ fontSize: "18px", fontWeight: 700, color: "#1e293b", margin: 0 }}>New Collection</h3>

                        <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                          <label style={{ fontSize: "13px", fontWeight: 500, color: "#475569" }}>Name</label>
                          <input
                            type="text"
                            placeholder="e.g. Summer 2027"
                            value={folderData.name}
                            onChange={(e) => setFolderData({ ...folderData, name: e.target.value })}
                            style={{
                              border: "1px solid #e2e8f0",
                              borderRadius: "8px",
                              width: "100%",
                              outline: "none",
                              fontSize: "14px",
                              padding: "10px 14px",
                              background: "white",
                              transition: "border-color 0.2s"
                            }}
                          />
                        </div>

                        <div style={{ display: "flex", gap: "16px" }}>
                          <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "6px" }}>
                            <label style={{ fontSize: "13px", fontWeight: 500, color: "#475569" }}>Season</label>
                            <ReactSelect
                              placeholder="Select Season"
                              options={options_season}
                              value={options_season.find(o => o.value === folderData.season)}
                              onChange={(val: any) => setFolderData({ ...folderData, season: val.value })}
                              styles={customStylesCreateModern}
                            />
                          </div>
                          <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "6px" }}>
                            <label style={{ fontSize: "13px", fontWeight: 500, color: "#475569" }}>Year</label>
                            <ReactSelect
                              placeholder="Select Year"
                              options={options_year}
                              value={options_year.find(o => o.value === folderData.year)}
                              onChange={(val: any) => setFolderData({ ...folderData, year: val.value })}
                              styles={customStylesCreateModern}
                            />
                          </div>
                        </div>

                        <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                          <label style={{ fontSize: "13px", fontWeight: 500, color: "#475569" }}>Collaborators</label>
                          <ReactSelect
                            isMulti
                            placeholder="Search names..."
                            options={collaborators?.map((c: any) => ({ label: c.name, value: c.id }))}
                            onChange={(val: any) => setFolderData({ ...folderData, collaborator: val.map((v: any) => v.value) })}
                            styles={customStylesCreateModern}
                          />
                        </div>

                        <div className="buttons_grid" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px", marginTop: "8px" }}>
                          <button
                            className="btn_modern_cancel"
                            onClick={() => setShowCollectionForm(false)}
                            style={{
                              padding: "12px",
                              borderRadius: "10px",
                              border: "1px solid #e1e8f0",
                              background: "white",
                              fontSize: "14px",
                              fontWeight: 600,
                              cursor: "pointer",
                              transition: "all 0.2s"
                            }}
                          >
                            Cancel
                          </button>
                          <button
                            className="btn_modern_confirm"
                            onClick={handleCreateNewFolder}
                            style={{
                              padding: "12px",
                              borderRadius: "10px",
                              border: "none",
                              background: "#00468c",
                              color: "white",
                              fontSize: "14px",
                              fontWeight: 600,
                              cursor: "pointer",
                              transition: "all 0.2s"
                            }}
                          >
                            Create
                          </button>
                        </div>
                      </div>
                    ) : (
                      <>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
                          <span style={{ fontSize: "14px", fontWeight: 600, color: "#64748b" }}>Choose a collection</span>
                          <Tooltip title="Create New Collection">
                            <button
                              onClick={() => setShowCollectionForm(true)}
                              style={{
                                width: "36px",
                                height: "36px",
                                borderRadius: "50%",
                                border: "1px solid #e1e8f0",
                                background: "white",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: "pointer",
                                color: "#00468c",
                                transition: "all 0.2s"
                              }}
                            >
                              <PlusIcon />
                            </button>
                          </Tooltip>
                        </div>

                        <div className="list_folders" style={{ display: "grid", gridTemplateColumns: "repeat(2,1fr)", gap: "8px", maxHeight: "300px", overflowY: "auto", padding: "10px" }}>
                          {folders.folders &&
                            folders.folders
                              .filter((el: any) => el.client_id == user.id)
                              .map((folder: any) => (
                                <Folder
                                  clickable={true}
                                  selectOneFolder={true}
                                  addToCollection={true}
                                  folder={folder}
                                  key={folder.id}
                                />
                              ))}
                        </div>

                        <div className="buttons_grid" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px", marginTop: "20px" }}>

                          <button
                            className="btn_modern_confirm"
                            onClick={() => {
                              if (folders.folderIdToMoveTo) {
                                dispatch(addProducttoFolder(folders.folderIdToMoveTo, quickViewProduct?.id));
                                dispatch(clearfolderToMoveTo());
                              } else {
                                message.error("Please select a collection first");
                              }
                            }}
                            style={{
                              padding: "8px",
                              borderRadius: "8px",
                              border: "none",
                              background: "#00468c",
                              color: "white",
                              fontSize: "13px",
                              fontWeight: 600,
                              cursor: "pointer"
                            }}
                          >
                            Confirm
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                )}
              </div>
            </div>
            <div style={{ padding: "10px 30px 20px" }}>
              <Link
                to={`/product/details/${quickViewProduct.fabric_type || 'all'}/${quickViewProduct.gender_id || 'all'}/${quickViewProduct.category_id || 'all'}/${quickViewProduct.name}/${quickViewProduct.id}`}
                className="ant-btn ant-btn-primary ant-btn-block"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "50px",
                  fontSize: "16px",
                  borderRadius: "4px",
                  backgroundColor: "#000",
                  borderColor: "#000",
                  fontWeight: "bold",
                  textTransform: "uppercase"
                }}
              >
                VIEW FULL DETAILS
              </Link>
            </div>
          </div>
        )}
      </Drawer>
      <BottomDrawer mode="add_to_collection" />
    </main>
  );
};
